import useApplyFilter from "components/Filters/useApplyFilter";
import {
  PolicyTemplateSuggestions,
  searchPolicyTemplateSuggestionsDictionary,
} from "constants/policy";
import TableCellLabels from "ds/components/Table/Row/CellLabels";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { PolicyTemplate } from "types/generated";

const APPLY_FILTERS_SUGGESTIONS = {
  searchSuggestionsDictionary: searchPolicyTemplateSuggestionsDictionary,
};

const PoliciesTemplatesTableLabelsCell = ({
  item: template,
  ...cellProps
}: TableSimpleCellProps<PolicyTemplate>) => {
  const { applyLabelFilter } =
    useApplyFilter<PolicyTemplateSuggestions>(APPLY_FILTERS_SUGGESTIONS);

  return (
    <TableSimpleCell {...cellProps}>
      <TableCellLabels
        tags={template.labels}
        applyLabelFilter={applyLabelFilter(PolicyTemplateSuggestions.Label)}
      />
    </TableSimpleCell>
  );
};

export default PoliciesTemplatesTableLabelsCell;
